import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { styled } from '@mui/material/styles'

const PURPLE_THEME = {
  primary: '#7450aa',
  light: '#8b6eb8',
  lightBg: 'rgba(194, 178, 218, 0.12)',
}

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: '12px !important',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  border: '1px solid',
  borderColor: theme.palette.divider,
  overflow: 'hidden',
  '&:before': { display: 'none' },
  '&.Mui-expanded': { margin: 0 },
  '& + &': { marginTop: theme.spacing(1.5) },
}))

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: 52,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1.5),
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
  '&.Mui-expanded': {
    minHeight: 52,
    backgroundColor: theme.palette.mode === 'light' ? '#faf9fc' : theme.palette.grey[900],
  },
  '& .MuiAccordionSummary-content': {
    margin: theme.spacing(1.5, 0),
    alignItems: 'center',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: PURPLE_THEME.primary,
  },
}))

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2, 2, 2.5),
  borderTop: '1px solid',
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
}))

export default function StyledAccordionSectionWrapper({
  headerComponents,
  heading,
  children,
  sectionContainerSx = {},
  sectionContainerProps = {},
  expandedOnDefault = false,
  defaultExpanded,
  unmountOnExit = false,
}) {
  const isExpanded = defaultExpanded ?? expandedOnDefault

  return (
    <Grid item xs={12} {...sectionContainerProps} sx={sectionContainerSx}>
      <StyledAccordion
        slotProps={{ transition: { unmountOnExit } }}
        defaultExpanded={isExpanded}
      >
        <StyledAccordionSummary expandIcon={<ExpandMore />}>
          {heading && !headerComponents ? (
            <Typography variant="subtitle1" fontWeight={600} color="text.primary">
              {heading}
            </Typography>
          ) : (
            headerComponents
          )}
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Grid container spacing={2}>
            {children}
          </Grid>
        </StyledAccordionDetails>
      </StyledAccordion>
    </Grid>
  )
}
